import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, ToastController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GrupoProvider } from 'src/app/services/grupo/grupo';

@Component({
  selector: 'app-grupo-motivo-desligamento',
  templateUrl: './grupo-motivo-desligamento.page.html',
  styleUrls: ['./grupo-motivo-desligamento.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ReactiveFormsModule
  ],
})
export class GrupoMotivoDesligamentoPage implements OnInit {
  validations_form: FormGroup;
  idGrupo: any;
  participante: any = {};
  tipo: any;
  idParticipante: any;
  ocorrencias: any = [];
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private translate: TranslateService,
    public grupoProvider: GrupoProvider,
    private formBuilder: FormBuilder,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
  ) {
    this.validations_form = this.formBuilder.group({
      anotacao: new FormControl('', Validators.required),
      ocorrencias: new FormControl('', Validators.required),
    });
    this.idGrupo = navParams.get('idGrupo');
    this.participante = this.navParams.get('participante');
    this.tipo = this.navParams.get('tipo');

    this.idParticipante = this.participante.id;

    this.grupoProvider.getTipoOcorrencia().subscribe((data) => {
      this.ocorrencias = data;
    })

  }

  ngOnInit() {
  }

  public closeModal() {
    this.modalCtrl.dismiss(false);
  }

  onSubmit(form: any) {
    this.grupoProvider.removerParticipante(this.idGrupo, this.idParticipante).subscribe(() => { });

    this.grupoProvider.solicitacaoDesligamento(this.idGrupo, this.idParticipante, form, this.tipo).subscribe(async data => {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('Sua solicitação foi enviada com sucesso!'),
        duration: 3000
      });

      toast.present();

      this.modalCtrl.dismiss(data);
    });
  }

  ionViewDidLoad() { }
}
